import { render, staticRenderFns } from "./VehicleTypeAdd.vue?vue&type=template&id=18cabadc"
import script from "./VehicleTypeAdd.vue?vue&type=script&lang=js"
export * from "./VehicleTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./VehicleTypeAdd.vue?vue&type=style&index=0&id=18cabadc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports